import { useState } from "react";
import Header from "../../../../customs/Header";
//import ScoreSetupContent from "./scoreSetup";
import { ReactComponent as World } from "../../../../svg/world.svg";
import CreateExamEntryLevelSetUp from "./createExamEntryLevelSetup";
import SettingsModal from "../SettingsModal/settingsModal";
import MainContent from "./mainContent";

export const Main = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openRoleModal, setOpenRoleModal] = useState(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  const handleOpenRoleModal = () => setOpenRoleModal(true);

  return (
    <section>
      <Header
        props={{
          firstName: "All",
          secondName: "Exam Entry Level Setup",
          buttonText: "Create Exam Entry Level",
        }}
        handleOpen={handleOpenCreateModal}
      />

      <MainContent handleClick={handleOpenRoleModal} />

      <SettingsModal
        header="Create Exam Entry Level"
        open={openCreateModal}
        maxWidth={"712px"}
        content={<CreateExamEntryLevelSetUp handleClose={handleCloseCreateModal}  />}
        cancel={setOpenCreateModal}
        showrightIcon={false}
        worldIcon={<World/>}
      />

      
    </section>
  );
};

export default Main;

